export enum OverlappingAction {
  MOVE_TO_TOP = 'move_to_top',
  MOVE_TO_BOTTOM = 'move_to_bottom',
  MOVE_FORWARD = 'move_forward',
  MOVE_BACKWARD = 'move_backward',
}
